/*
  Bootstrap shim. Despite the filename, Afterpay messaging is PARKED - this
  file now loads the assets that replaced it:

    melo-paylater.js    PayPal Pay Later on-site messaging
    melo-elevate.css    raised buy panel + press feedback on every control
    melo-cart.css       compact Subscribe & Save box in the cart drawer

  Why a shim instead of editing theme.liquid: theme.liquid already carries
  <script src="{{ 'melo-afterpay.js' | asset_url }}" defer></script>, so this
  ships them without rewriting a 13KB layout file. It resolves its siblings
  from its own script URL, so it survives theme version bumps.

  TIDY-UP when theme.liquid is next edited, replace these two lines:

    <script src="https://js.squarecdn.com/square-marketplace.js" async></script>
    <script src="{{ 'melo-afterpay.js' | asset_url }}" defer></script>

  with these three:

    {{ 'melo-elevate.css' | asset_url | stylesheet_tag }}
    {{ 'melo-cart.css' | asset_url | stylesheet_tag }}
    <script src="{{ 'melo-paylater.js' | asset_url }}" defer></script>

  then this file can go. That also drops the square-marketplace.js request,
  which currently loads and does nothing, moves the stylesheets into the
  initial paint instead of arriving just after it, and removes the cache
  coupling described next.

  CACHE COUPLING - READ THIS BEFORE EDITING A SIBLING.
  The sibling URLs are derived from this file's own ?v= hash. Shopify only
  changes that hash when THIS file changes, so editing melo-paylater.js,
  melo-elevate.css or melo-cart.css on their own leaves browsers serving the
  cached copies. Whenever you change any sibling, bump BUILD below and
  re-upload this file too. That is the whole fix - the hash does the rest.

  The Afterpay implementation is recorded in full in the project doc
  claude/afterpay-onsite-messaging-v74.md, along with why it never rendered.
*/
(function () {
  'use strict';

  var BUILD = 18;  /* bump when any sibling asset changes */

  var self = document.currentScript;
  if (!self || !self.src) return;

  var base = self.src;

  /* Both stylesheets are shadow, transform and grid-template only on elements
     that already exist, so neither moves layout on arrival. */
  function css(name, id) {
    var href = base.replace('melo-afterpay.js', name);
    if (href === base || document.getElementById(id)) return;
    var l = document.createElement('link');
    l.id = id;
    l.rel = 'stylesheet';
    l.href = href;
    document.head.appendChild(l);
  }

  css('melo-elevate.css', 'melo-elevate-css');
  css('melo-cart.css', 'melo-cart-css');

  var src = base.replace('melo-afterpay.js', 'melo-paylater.js');
  if (src !== base && !document.getElementById('melo-paylater-js')) {
    var s = document.createElement('script');
    s.id = 'melo-paylater-js';
    s.src = src;
    s.defer = true;
    document.head.appendChild(s);
  }

  void BUILD;
})();
